import {isNullOrUndefined} from "../../services/Validator";

export default function SystemDesktopTopBarLayout({children, extraClass}) {
    // Used through the app to frame top bar in mobile mode

    // BUILD
    if (isNullOrUndefined(children))
        return null;
    return (
        <div className={"bg-backgroundLight1 w-full h-[72px] min-h-[72px] max-h-[72px] flex justify-between items-center px-[16px] lg:px-[24px] " + extraClass}>
            {children}
        </div>
    );
}